var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "q-card",
      class: _vm.shadow ? "is-" + _vm.shadow + "-shadow" : "is-always-shadow",
      attrs: { amn: "amin" },
    },
    [
      _vm.$slots.header || _vm.header
        ? _c(
            "div",
            { staticClass: "q-card__header" },
            [
              _vm._t("header", function () {
                return [_vm._v("\n      " + _vm._s(_vm.header) + "\n    ")]
              }),
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "q-card__body", style: _vm.bodyStyle },
        [_vm._v("\n    amin\n    "), _vm._t("default")],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }